module.exports = __webpack_public_path__ + "img/cf-cb.ef71260f.png";